import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

import { setUnauthorizedHandler } from '@/api/client';
import { router } from '@/routes/router';

export function App() {
  useEffect(() => {
    setUnauthorizedHandler(() => {
      router.navigate('/login', { replace: true });
    });
  }, []);

  // future.v7_startTransition wraps router state updates in React.startTransition,
  // matching the v7 default. Silences the v6 dev-only future-flag warning and
  // smooths large route transitions. Non-breaking opt-in.
  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
}
